/** biome-ignore-all lint/suspicious/noExplicitAny: keep component generic */
import type { PropsWithChildren } from 'react';

export type Data = Record<string, any>[];

export interface LabelKeyObject {
    label: string;
    key: string;
}
export type Headers = LabelKeyObject[];

export const ExportCSV = ({
    data,
    fileName,
    headers,
    iconOnlyButton,
    children,
}: PropsWithChildren<{ data: Data; headers: Headers; fileName?: string; iconOnlyButton?: boolean }>) => {
    const downloadCSV = () => {
        // Convert the data array into a CSV string
        const csvString = [
            headers.map(it => it.label), // Specify your headers here
            ...data.map(item => headers.map(it => it.key).map(header => item[header])), // Map your data fields accordingly
        ]
            .map(row => row.join(','))
            .join('\n');

        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: 'text/csv' });

        // Generate a download link and initiate the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <button
            className={`btn btn-primary${iconOnlyButton ? ' btn-icon-only' : ''}`}
            type={'button'}
            onClick={downloadCSV}
        >
            {children}
        </button>
    );
};
